module.exports = __webpack_public_path__ + "img/weixinD.974e12c2.png";